import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const SculpturedLeatherBlazer = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.jackets.SculpturedLeatherBlazer.itemName}
      name={AW23.jackets.SculpturedLeatherBlazer.itemName}
      price={AW23.jackets.SculpturedLeatherBlazer.itemPrice}
      fabric={AW23.jackets.SculpturedLeatherBlazer.itemFabric}
      src={AW23.jackets.SculpturedLeatherBlazer.sizeChart}
      divId={AW23.jackets.SculpturedLeatherBlazer.shopifyDivId}
      mainId={AW23.jackets.SculpturedLeatherBlazer.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.jackets.SculpturedLeatherBlazer.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.jackets.SculpturedLeatherBlazer.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default SculpturedLeatherBlazer;
